import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 18 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.2377 5.66L12.6816 0.71L12.1954 0.5H1.47187L0.777344 1.25V9.5H2.1664V2H10.5008V7.25L11.1953 8H16.057V9.5H17.4461V6.2L17.2377 5.66ZM11.8898 6.5V2L16.057 6.5H11.8898ZM1.47187 11L0.777344 11.75V20.75L1.47187 21.5H16.7515L17.4461 20.75V11.75L16.7515 11H1.47187ZM16.057 18.5V20H2.1664V12.5H16.057V18.5Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.27102 18H6.52653L6.52163 15.9429L5.51265 17.6376H5.1551L4.15102 15.9869V18H3.40653V14.5714H4.06286L5.34612 16.702L6.6098 14.5714H7.26122L7.27102 18ZM9.56855 14.5714C10.4845 14.5714 11.0575 15.0465 11.0575 15.8155C11.0575 16.5796 10.4845 17.0547 9.56855 17.0547H8.87793V18H8.08446V14.5714H9.56855ZM9.52446 16.4082C10.0094 16.4082 10.2543 16.1878 10.2543 15.8155C10.2543 15.4384 10.0094 15.218 9.52446 15.218H8.87793V16.4082H9.52446ZM14.4476 16.6335V17.28H13.8893V18H13.1154V17.28H11.2689V16.7461L12.8852 14.5714H13.7178L12.2191 16.6335H13.1399V15.9918H13.8893V16.6335H14.4476Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }